import { Timestamp } from "firebase/firestore";
import { CartStatus, CartType } from "../../../models/CartType";
import { StringsService } from "../../../services/strings/strings";
import { OrderTransaction } from "../billingData";


const isRefunded = (status: CartStatus) => {
    if (
        status == "FULL_REFUND_COMPLETE" ||
        status == "FULL_REFUND_PROCESSING" ||
        status == "PARTIAL_REFUND_COMPLETE" ||
        status == "PARTIAL_REFUND_PROCESSING"
    ) { return true; }
    return false
}

// TODO: Keep in sync with Firebase Functions
export async function mapCartToTransaction(cart: CartType): Promise<OrderTransaction> {
    let gross = Math.round(cart.totalAmount) / 100;     // if you’re storing cents
    const fee = Math.round(cart.yocoFee + cart.ecoeatsFee) / 100;
    let net = gross - fee;
    const type = isRefunded(cart.status) ? 'refund' : 'order';
    if (cart.status == "FULL_REFUND_COMPLETE"  || cart.status == "FULL_REFUND_PROCESSING") {
        net = 0
        gross = 0
    }
    if (cart.status == "PARTIAL_REFUND_COMPLETE" || cart.status == "PARTIAL_REFUND_PROCESSING") {
        net -= Math.round(cart.refundedAmount) / 100
        gross -= Math.round(cart.refundedAmount) / 100
    }
    const itemPromises: Array<Promise<string>> = cart.items.map(async (item) => {
        return `${item.menuCartItem.name} x ${item.quantity}`
    })
    const items = await Promise.all(itemPromises)
    let dateStr = ""
    console.log(cart.yocoPaymentCompletedAt)
    try {
        dateStr = (cart.yocoPaymentCompletedAt as any as Timestamp).toDate().toISOString().slice(0, 10)
    } catch (error) {
        try {
        dateStr = (cart.yocoPaymentCompletedAt as any as string).slice(0, 10)
        } catch (error) {
            
        }
    }
    return {
        id: cart.id,
        date: dateStr,
        orderId: cart.id,
        customer: cart.customerId, // you might look up their name separately
        items: items.join(', '),
        grossAmount: gross,
        fee,
        netAmount: net,
        type,
    };
}